import { render } from "./editTemplateProposalComponent.vue?vue&type=template&id=17b206ea&scoped=true"
import script from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./editTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./editTemplateProposalComponent.vue?vue&type=style&index=0&id=17b206ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b206ea"]])

export default __exports__